import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import About from '@/pages/About';
import ServicesOverview from '@/pages/ServicesOverview';
import ProjectsOverview from '@/pages/ProjectsOverview';
import Contact from '@/pages/Contact';

// Service Pages
import EvaporatorsService from '@/pages/services/Evaporators';
import DryersService from '@/pages/services/Dryers';
import DairyEquipment from '@/pages/services/DairyEquipment';
import MixersService from '@/pages/services/Mixers';
import AccessoriesService from '@/pages/services/Accessories';
import HerbalExtractionService from '@/pages/services/HerbalExtraction';

// Project Pages - Dairy
import LiquidMilkProject from '@/pages/projects/LiquidMilk';
import GheeProject from '@/pages/projects/Ghee';
import DahiLassiProject from '@/pages/projects/DahiLassi';
import SMPWMPProject from '@/pages/projects/SMPWMP';
import PaneerProject from '@/pages/projects/Paneer';
import KhoaProject from '@/pages/projects/Khoa';
import IceCreamProject from '@/pages/projects/IceCream';
import SweetenedMilkProject from '@/pages/projects/SweetenedMilk';
import ButterOilProject from '@/pages/projects/ButterOil';
import CaseinProject from '@/pages/projects/Casein';
import MaltedMilkProject from '@/pages/projects/MaltedMilk';
import FlavoredMilkProject from '@/pages/projects/FlavoredMilk';

// Project Pages - Other
import EffluentProject from '@/pages/projects/Effluent';
import TeaCoffeeProject from '@/pages/projects/TeaCoffee';
import StarchMaltProject from '@/pages/projects/StarchMalt';
import FruitsVegetablesProject from '@/pages/projects/FruitsVegetables';

function App() {
  return (
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<ServicesOverview />} />
          <Route path="/projects" element={<ProjectsOverview />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* Service Routes */}
          <Route path="/services/evaporators" element={<EvaporatorsService />} />
          <Route path="/services/dryers" element={<DryersService />} />
          <Route path="/services/dairy-equipment" element={<DairyEquipment />} />
          <Route path="/services/mixers" element={<MixersService />} />
          <Route path="/services/accessories" element={<AccessoriesService />} />
          <Route path="/services/herbal-extraction" element={<HerbalExtractionService />} />
          
          {/* Project Routes - Dairy */}
          <Route path="/projects/liquid-milk" element={<LiquidMilkProject />} />
          <Route path="/projects/ghee" element={<GheeProject />} />
          <Route path="/projects/dahi-lassi" element={<DahiLassiProject />} />
          <Route path="/projects/smp-wmp" element={<SMPWMPProject />} />
          <Route path="/projects/paneer" element={<PaneerProject />} />
          <Route path="/projects/khoa" element={<KhoaProject />} />
          <Route path="/projects/ice-cream" element={<IceCreamProject />} />
          <Route path="/projects/sweetened-milk" element={<SweetenedMilkProject />} />
          <Route path="/projects/butter-oil" element={<ButterOilProject />} />
          <Route path="/projects/casein" element={<CaseinProject />} />
          <Route path="/projects/malted-milk" element={<MaltedMilkProject />} />
          <Route path="/projects/flavored-milk" element={<FlavoredMilkProject />} />
          
          {/* Project Routes - Other */}
          <Route path="/projects/effluent" element={<EffluentProject />} />
          <Route path="/projects/tea-coffee" element={<TeaCoffeeProject />} />
          <Route path="/projects/starch-malt" element={<StarchMaltProject />} />
          <Route path="/projects/fruits-vegetables" element={<FruitsVegetablesProject />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;